import Vue from 'vue'
import Router from 'vue-router'
import Spare from './components/spare/Spare.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/Test',
      name: 'spare',
      component: Spare
    },
    {
      path: '/lv/test',
      name: 'spare',
      component: Spare
    },
    {
      path: '/en/test',
      name: 'spare',
      component: Spare
    },
    {
      path: '/Yamaha-Genuine-Ersatzteile',
      name: 'spare',
      component: Spare
    },
    {
      path: '/KTM-Teilesuche',
      name: 'spare',
      component: Spare
    },
    {
      path: '/Husqvarna-Motorcycle-Spareparts-Ersatzteile',
      name: 'spare',
      component: Spare
    },
    {
      path: '/spare-parts-finder',
      name: 'spare',
      component: Spare
    },
    {
      path: '/GASGAS-OEM-Original-Ersatzteilsuche',
      name: 'spare',
      component: Spare
    },
    {
      path: '/OEM-Original-Ersatzteilsuche',
      name: 'spare',
      component: Spare
    },
    {
      path: '/spf-ktm-test/',
      name: 'spare',
      component: Spare
    },
    {
      path: '/ktm-original-ersatzteilsuche/',
      name: 'spare',
      component: Spare
    },
    {
      path: '/spf-hqv-test/',
      name: 'spare',
      component: Spare
    },
    {
      path: '/husqvarna-original-ersatzteilsuche/',
      name: 'spare',
      component: Spare
    },
    {
      path: '/spf-gasgas-test/',
      name: 'spare',
      component: Spare
    },
    {
      path: '/gasgas-original-ersatzteilsuche/',
      name: 'spare',
      component: Spare
    },
  ]
})
